import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { GLOBAL_ROUTES as AppRoutes } from "../Router";

const CustomerManual = lazy(() => import("../components/Manual"));
const Payment = lazy(() => import("./panels/Payment"));
const Information = lazy(() => import("./panels/CustomerInformation"));
const ChangePassword = lazy(() => import("./panels/ChangePassword2"));
const ChangeEmail = lazy(() => import("./panels/ChangeEmail"));
const EmailOTP = lazy(() => import("./panels/EmailOTP"));

export const CLIENT_ROUTES: Record<ClientRouteKeys, AppRoute> = {
  payment: {
    path: "/",
    exact: true,
    component: Payment,
    name: "Client - Payment Invoice",
  },
  manual: {
    path: "/manual",
    exact: true,
    component: CustomerManual,
    name: "Client - Customer Manual",
  },
  information: {
    path: "/information",
    exact: true,
    component: Information,
    name: "Client - Information",
  },
  changePassword: {
    path: "/change-password-2",
    exact: true,
    component: ChangePassword,
    name: "Client - Change Password",
  },
  changeEmail: {
    path: "/change-email",
    exact: true,
    component: ChangeEmail,
    name: "Client - Change Email",
  },
  emailOtp: {
    path: "/email-otp-2",
    exact: true,
    component: EmailOTP,
    name: "Client - Email OTP",
  },
};

function Router() {
  const clientRoutes = Object.values(CLIENT_ROUTES).map((route) => (
    <Route
      key={route.path}
      {...route}
      // path={`/app${route.path}`}
      path={
        `${route.path}` + (route.params ? "/:" + route.params?.join("/:") : "")
      }
      component={route.component}
    />
  ));
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>{clientRoutes}</Switch>
    </Suspense>
  );
}

export default Router;

// Types
type ClientRouteKeys =
  | "manual"
  | "payment"
  | "information"
  | "changePassword"
  | "changeEmail"
  | "emailOtp";
